// @core/api/endpoints/task/create_template.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  TaskCreateTemplateRequest,
  TaskTemplateResponse,
} from '../../../types/task';

const BASE_PATH = '/task';

/**
 * Create template
 * Creates a reusable task template with predefined fields, checklists, and settings. Templates speed up task creation for common task types.
 */
export async function CreateTemplate(
  data: TaskCreateTemplateRequest,
  options?: RequestOptions
): Promise<TaskTemplateResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/task-templates`;
  const requestOptions = options;
  return client.post<TaskTemplateResponse>(requestPath, data, requestOptions);
}
